module.exports = __webpack_public_path__ + "images/404-bg-mob.b400cc7ce7.png";